import { render, staticRenderFns } from "./ViewLeaveRequestDialog.vue?vue&type=template&id=06e34fae&"
import script from "./ViewLeaveRequestDialog.vue?vue&type=script&lang=ts&"
export * from "./ViewLeaveRequestDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLeaveRequestDialog.vue?vue&type=style&index=0&id=06e34fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports